import { Api } from "../../Utils/api"
import { error99 } from "../../Utils/Types"

export type ResTop10Produtos = {
    idProduto: number,
    descricao: string,
    qtd: number,
    vlTot: number,
}

export type ResVendaMensal = {
    mes: string,
    valor: number,
}

export type ResVendaFpagto = {
    descricao: string,
    valor: number,
}


//---------------------------------------------------------------------------------
export type RelDadosCtaPagar = {
    DadosCtaPagar: CtaPagar[]
    total: number

}

export type CtaPagar = {
    id: number,
    vencimento: string,
    numDoc: string,
    valor: number,
    nomeFornecedor: string,
}


// --------------------------------------------------------------------------------
export type RelDadosLanctoCartao = {
    DadosLanctoCartao: Cartao[]
    total: number
}

export type Cartao = {
    id: number,
    dt_vencimento: string,
    numero_transacao: string,
    valor: number,
    name_cliente: string,
}


//---------------------------------------------------------------------------------
export type RelDadosCtaReceber = {
    DadosCtaReceber: CtaReceber[]
    total: number

}

export type CtaReceber = {
    id: number,
    vencimento: string,
    observacao: string,
    valor: number,
    nomeFornecedor: string,
}


//---------------------------------------------------------------------------------
export type RelDadosEstoque = {
    DadosEstoque: DadosEstoque[]
    total: number

}

export type DadosEstoque = {
    id: number,
    descricao: string,
    estoque_fisico: number,
    estoque_minimo: number,
}


//---------------------------------------------------------------------------------
export type RelDadosSaldoContas = {
    DadosSaldo: DadosSaldoContas[]
    total: number

}

export type DadosSaldoContas = {
    id: number,
    descricao: string,
    saldo: number,
}


//---------------------------------------------------------------------------------
type DadosDashboard = {
    receita: number,
    despesa: number,
    venda: number,
    valorChequeDeposito: number,
    ticketMedioVenda: number,
    resVendaMensal: ResVendaMensal[],
    resVendaFpagto: ResVendaFpagto[],
    resTop10Produtos: ResTop10Produtos[],
    ctaPagarList: RelDadosCtaPagar,
    ctaReceberList: RelDadosCtaReceber,
    lanctoCartaoList: RelDadosLanctoCartao,
    produtoEstoque: RelDadosEstoque,
    saldoConta: RelDadosSaldoContas,
}

export const HomeService = {

    GetData: async (datai: string, dataf: string): Promise<DadosDashboard> => {
        const resp = await Api('Dashboard/Data', 'get', { datai, dataf })

        if (resp.data) {

            let resVendaMensal: ResVendaMensal[] = []
            let resVendaFpagto: ResVendaFpagto[] = []
            let resTop10Produtos: ResTop10Produtos[] = []
            let ctaPagarList: RelDadosCtaPagar = { DadosCtaPagar: [], total: 0 }
            let ctaReceberList: RelDadosCtaReceber = { DadosCtaReceber: [], total: 0 }
            let lanctoCartaoList: RelDadosLanctoCartao = { DadosLanctoCartao: [], total: 0 }
            let prodEstoque: RelDadosEstoque = { DadosEstoque: [], total: 0 }
            let saldo: RelDadosSaldoContas = { DadosSaldo: [], total: 0 }

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === "1") {

                return {
                    receita: 0,
                    despesa: 0,
                    venda: 0,
                    resVendaMensal: [],
                    resVendaFpagto: [],
                    resTop10Produtos: [],
                    ctaPagarList: { DadosCtaPagar: [], total: 0 },
                    ctaReceberList: { DadosCtaReceber: [], total: 0 },
                    lanctoCartaoList: { DadosLanctoCartao: [], total: 0 },
                    produtoEstoque: { DadosEstoque: [], total: 0 },
                    saldoConta: { DadosSaldo: [], total: 0 },
                    valorChequeDeposito: 0,
                    ticketMedioVenda: 0,
                }

            } else {

                // GRAFICO DE VENDAS POR MÊS =============================================================================
                resVendaMensal = await resp.data.res_venda_mensal.map((item: any) => {
                    return {
                        mes: item.mes,
                        valor: item.valor,
                    }
                })


                // GRAFICO DE FORMAS DE PAGAMENTO =========================================================================
                resVendaFpagto = await resp.data.res_venda_fpagto.map((item: any) => {
                    return {
                        descricao: item.descricao,
                        valor: item.total,
                    }
                })


                // CONTAS A RECEBER ========================================================================================
                ctaReceberList.total = await resp.data.cta_receber_list.total

                ctaReceberList.DadosCtaReceber = await resp.data.cta_receber_list.data.map((item: any) => {
                    return {
                        id: item.id,
                        vencimento: item.data_vencimento,
                        observacao: item.observacao,
                        valor: item.valor,
                        nomeFornecedor: item.nome_fantasia,
                    }
                })


                // CONTAS A PAGAR ========================================================================================
                ctaPagarList.total = await resp.data.cta_pagar_list.total

                ctaPagarList.DadosCtaPagar = await resp.data.cta_pagar_list.data.map((item: any) => {
                    return {
                        id: item.id,
                        vencimento: item.dt_vencimento,
                        numDoc: item.num_doc,
                        valor: item.valor,
                        nomeFornecedor: item.nome,
                    }
                })


                // LANÇAMENTO DE CARTÃO ===================================================================================
                lanctoCartaoList.total = await resp.data.lancto_cartao_list.total

                lanctoCartaoList.DadosLanctoCartao = await resp.data.lancto_cartao_list.data.map((item: any) => {
                    return {
                        id: item.id,
                        dt_vencimento: item.dt_vencimento,
                        numero_transacao: item.numero_transacao,
                        valor: item.valor,
                        name_cliente: item.name_cliente,
                    }
                })


                // TOP 10 PRODUTOS MAIS VENDIDOS ========================================================================
                resTop10Produtos = await resp.data.venda_top10_produtos.map((item: any) => {
                    return {
                        descricao: item.descricao,
                        idProduto: item.id_produto,
                        qtd: item.qtd,
                        vlTot: item.vl_tot,
                    }
                })


                // SALDO DAS CONTAS ==========================================================================================
                saldo.total = await resp.data.saldo_contas_list.total

                saldo.DadosSaldo = await resp.data.saldo_contas_list.data.map((item: any) => {
                    return {
                        id: item.id,
                        descricao: item.descricao,
                        saldo: item.saldo,
                    }
                })


                // PRODUTOS SEM ESTOQUE ========================================================================================
                prodEstoque.total = await resp.data.reposicao_estoque.total

                prodEstoque.DadosEstoque = await resp.data.reposicao_estoque.data.map((item: any) => {
                    return {
                        id: item.id,
                        descricao: item.descricao,
                        estoque_fisico: item.estoque_fisico,
                        estoque_minimo: item.estoque_minimo,
                    }
                })


                return {
                    receita: resp.data.receita,
                    despesa: resp.data.despesa,
                    venda: resp.data.venda,
                    resVendaMensal: resVendaMensal,
                    resVendaFpagto: resVendaFpagto,
                    resTop10Produtos: resTop10Produtos,
                    ctaPagarList: { DadosCtaPagar: ctaPagarList.DadosCtaPagar, total: ctaPagarList.total },
                    ctaReceberList: { DadosCtaReceber: ctaReceberList.DadosCtaReceber, total: ctaReceberList.total },
                    lanctoCartaoList: { DadosLanctoCartao: lanctoCartaoList.DadosLanctoCartao, total: lanctoCartaoList.total },
                    produtoEstoque: { DadosEstoque: prodEstoque.DadosEstoque, total: prodEstoque.total },
                    saldoConta: { DadosSaldo: saldo.DadosSaldo, total: saldo.total },
                    valorChequeDeposito: resp.data.valor_cheque_deposito,
                    ticketMedioVenda: resp.data.ticket_medio_venda,
                }
            }
        }

        return {
            receita: 0,
            despesa: 0,
            venda: 0,
            resVendaMensal: [],
            resVendaFpagto: [],
            resTop10Produtos: [],
            ctaPagarList: { DadosCtaPagar: [], total: 0 },
            ctaReceberList: { DadosCtaReceber: [], total: 0 },
            lanctoCartaoList: { DadosLanctoCartao: [], total: 0 },
            produtoEstoque: { DadosEstoque: [], total: 0 },
            saldoConta: { DadosSaldo: [], total: 0 },
            valorChequeDeposito: 0,
            ticketMedioVenda: 0,
        }
    },

    RelCtaPagar: async (datai: string, dataf: string, page: number): Promise<RelDadosCtaPagar> => {
        const resp = await Api('Dashboard/Data/RelPagarPage', 'get', { datai, dataf, page })

        const dados: RelDadosCtaPagar = { DadosCtaPagar: [], total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '0') {

                dados.total = resp.data.cta_pagar_list.total

                await resp.data.cta_pagar_list.data.map((item: any) =>
                    dados.DadosCtaPagar.push({
                        id: item.id,
                        nomeFornecedor: item.nome,
                        vencimento: item.dt_vencimento,
                        valor: item.valor,
                        numDoc: item.num_doc
                    })
                )
            }

        }

        return dados

    },

    RelCtaReceber: async (datai: string, dataf: string, page: number): Promise<RelDadosCtaReceber> => {
        const resp = await Api('Dashboard/Data/RelReceberPage', 'get', { datai, dataf, page })

        const dados: RelDadosCtaReceber = { DadosCtaReceber: [], total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '0') {

                dados.total = resp.data.cta_receber_list.total

                await resp.data.cta_receber_list.data.map((item: any) =>
                    dados.DadosCtaReceber.push({
                        id: item.id,
                        nomeFornecedor: item.nome_fantasia,
                        vencimento: item.data_vencimento,
                        valor: item.valor,
                        observacao: item.observacao
                    })
                )
            }

        }

        return dados

    },

    RelLanctoCartao: async (datai: string, dataf: string, page: number): Promise<RelDadosLanctoCartao> => {
        const resp = await Api('Dashboard/Data/RelLanctoCartaoPage', 'get', { datai, dataf, page })

        const dados: RelDadosLanctoCartao = { DadosLanctoCartao: [], total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '0') {

                dados.total = resp.data.lancto_cartao_list.total

                await resp.data.lancto_cartao_list.data.map((item: any) =>
                    dados.DadosLanctoCartao.push({
                        id: item.id,
                        name_cliente: item.name_cliente,
                        dt_vencimento: item.dt_vencimento,
                        valor: item.valor,
                        numero_transacao: item.numero_transacao
                    })
                )
            }

        }

        return dados

    },

    SaldoContas: async (page: number): Promise<RelDadosSaldoContas> => {
        const resp = await Api('Dashboard/Data/RelSaldoContasPage', 'get', { page })

        const dados: RelDadosSaldoContas = { DadosSaldo: [], total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '0') {

                dados.total = resp.data.saldo_contas_list.total

                await resp.data.saldo_contas_list.data.map((item: any) =>
                    dados.DadosSaldo.push({
                        id: item.id,
                        descricao: item.descricao,
                        saldo: item.saldo,
                    })
                )
            }

        }

        return dados

    },

    ProdutoReposicao: async (page: number): Promise<RelDadosEstoque> => {
        const resp = await Api('Dashboard/Data/RelReposicaoPage', 'get', { page })

        const dados: RelDadosEstoque = { DadosEstoque: [], total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '0') {

                dados.total = resp.data.reposicao_estoque.total

                await resp.data.reposicao_estoque.data.map((item: any) =>
                    dados.DadosEstoque.push({
                        id: item.id,
                        descricao: item.descricao,
                        estoque_fisico: item.estoque_fisico,
                        estoque_minimo: item.estoque_minimo,
                    })
                )
            }

        }

        return dados

    },

}